 import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
 import {ChannelsHeaderComponent} from '../channels/components/header/channels-header.component'
 import {RouterModule} from '@angular/router';
 import {LoaderComponent} from './components/loader/loader.component';
// import {SkeletonOverviewsComponent} from './components/skeleton-overviews/skeleton-overviews.component';
 import { ClipboardModule } from 'ngx-clipboard';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CdnControlComponent} from './components/cdn-control/cdn-control.component';
import {NumberSpacedPipe} from './classes/number-spaced.pipe';
 import {AdditionPercentagePipe} from './classes/addition-percentage.pipe';
 import {DateFormattedPipe} from './classes/date-formatted.pipe';
 import {WatchCountdownComponent} from './components/watch-countdown/watch-countdown.component';
 import {PaymentBuyCodeModalComponent} from './components/payment-buy-code-modal/payment-buy-code-modal.component';
 import {PaymentDonateModalComponent} from './components/payment-donate-modal/payment-donate-modal.component';
 
  import {IdeaModalComponent} from './components/idea-modal/idea-modal.component';
  import {GridDensityControlComponent} from './components/grid-density-control/grid-density-control.component';


import {
 NbMenuModule,
NbButtonModule,
NbInputModule,
NbIconModule,
NbFormFieldModule,
NbCardModule,
NbProgressBarModule,
NbRadioModule,
NbSelectModule,
NbSpinnerModule,
  NbPopoverModule,
NbAlertModule,
  NbToggleModule,
  NbCheckboxModule,
NbContextMenuModule
} from '@nebular/theme';
 
 
@NgModule({
  declarations: [
     ChannelsHeaderComponent,
     LoaderComponent,
 // SkeletonOverviewsComponent,
   CdnControlComponent,
	WatchCountdownComponent,

  // NumberSpacedPipe,
 AdditionPercentagePipe,
 DateFormattedPipe,
PaymentBuyCodeModalComponent,
PaymentDonateModalComponent,
IdeaModalComponent,
GridDensityControlComponent
  ],
  imports: [

 
    CommonModule,
  NbButtonModule,
  NbInputModule,
  NbIconModule,
  NbFormFieldModule, 
NbRadioModule,
  NbCardModule,
NbContextMenuModule,
  RouterModule,
NbProgressBarModule,
  FormsModule,
 ReactiveFormsModule,
NbPopoverModule,
NbSpinnerModule,
ClipboardModule,
//NumberSpacedPipe,
NbSelectModule,
NbAlertModule,  NbToggleModule,
  NbCheckboxModule,
    NbMenuModule.forRoot(),
    NgxSkeletonLoaderModule.forRoot()
  ], 

  exports: [
  NbButtonModule,
  NbInputModule,
  NbIconModule,
NbSelectModule,
  NbFormFieldModule,
NbProgressBarModule,
NbPopoverModule,
  NbCardModule,
  RouterModule,
NbSpinnerModule,
  CommonModule,
NbRadioModule,
  ChannelsHeaderComponent,
CdnControlComponent,
  LoaderComponent,
ClipboardModule,
  FormsModule ,
 ReactiveFormsModule,
 //NumberSpacedPipe,
 AdditionPercentagePipe,
 DateFormattedPipe,
WatchCountdownComponent,
NbAlertModule,  NbToggleModule,
  NbCheckboxModule,
NbContextMenuModule,
    NbMenuModule,
NgxSkeletonLoaderModule,

//SkeletonOverviewsComponent,
GridDensityControlComponent,
 ]
})
export class SharedModule {
}
